'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Request = require('d3-request');

var _taReactWemftracking = require('ta-react-wemftracking');

var _taReactWemftracking2 = _interopRequireDefault(_taReactWemftracking);

var _taReactGa = require('ta-react-ga');

var _taReactGa2 = _interopRequireDefault(_taReactGa);

var _taReactGtm = require('ta-react-gtm');

var _taReactGtm2 = _interopRequireDefault(_taReactGtm);

var _taReactNewsnettracker = require('ta-react-newsnettracker');

var _taReactNewsnettracker2 = _interopRequireDefault(_taReactNewsnettracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file One-size-fits-all tracking component, supports Google Analytics,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   Google Tag Manager, WEMF NetMetrix and internal Newsnet tracker.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Tracking = function (_React$Component) {
  _inherits(Tracking, _React$Component);

  function Tracking(props) {
    _classCallCheck(this, Tracking);

    // Use props to populate the default state
    var _this = _possibleConstructorReturn(this, (Tracking.__proto__ || Object.getPrototypeOf(Tracking)).call(this, props));

    _this.state = _extends({}, props);
    return _this;
  }

  _createClass(Tracking, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.rawSiteData) {
        this.extractDataAndSetState(nextProps.rawSiteData);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'small',
        { style: { position: 'absolute' } },
        this.state.wemfTrackingUrls && this.state.wemfTrackingUrls.length > 0 ? _react2.default.createElement(_taReactWemftracking2.default, { trackingUrls: this.state.wemfTrackingUrls }) : '',
        ' ',
        this.state.gaTrackers && this.state.gaTrackers.length > 0 ? _react2.default.createElement(_taReactGa2.default, { trackers: this.state.gaTrackers }) : '',
        ' ',
        this.state.gtmId ? _react2.default.createElement(_taReactGtm2.default, { gtmId: this.state.gtmId }) : '',
        ' ',
        this.props.articleId ? _react2.default.createElement(_taReactNewsnettracker2.default, { articleId: this.props.articleId }) : ''
      );
    }

    /**
     * Called once, after the initial rendering. Since we only try and request the
     * Site Data object now, we have to make sure that the render() method
     * won't render anything without having the required properties of it's
     * children elements.
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Raw Site Data has not been provided, start our own request to get it.
      if (!this.props.rawSiteData) {
        var hostname = window.location.hostname;

        // to avoid a error message on localhost
        if (hostname == 'localhost') {
          hostname = 'www.tagesanzeiger.ch';
          //return;
        }

        hostname = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1); // extract domain name from
        // host (crops subdomains like
        // interaktiv.)

        (0, _d3Request.json)('http://www.' + hostname + '/api/sites/default').get(function (error, siteData) {
          if (error) {
            console.log(error);
          }

          _this2.extractDataAndSetState(siteData);
        });
      } else {
        // We have been provided by the raw Site Data object, we just have to
        // parse it and get the data out
        this.extractDataAndSetState(this.props.rawSiteData);
      }
    }
  }, {
    key: 'extractDataAndSetState',
    value: function extractDataAndSetState(siteData) {
      var _this3 = this;

      var urlList = [];

      // Only track WEMF if we actually provide a project ID
      if ('projectId' in this.props && this.props.projectId !== '') {

        siteData.site.statistics.map(function (stat) {
          urlList.push(stat.desktop_url + 'interactive/' + _this3.props.projectId);
        });
      }

      this.setState({
        gaTrackers: siteData.site.google_analytics_information.trackers,
        gtmId: siteData.site.gtm_id,
        wemfTrackingUrls: urlList
      });
    }
  }]);

  return Tracking;
}(_react2.default.Component);

Tracking.propTypes = {
  projectId: _react2.default.PropTypes.string,
  rawSiteData: _react2.default.PropTypes.object,
  articleId: _react2.default.PropTypes.string
};

Tracking.defaultProps = {};

exports.default = Tracking;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-tracking/dist/index.js
// module id = 95
// module chunks = 0